import { Component } from '@angular/core';
import { Validators } from '@angular/forms';

import { Observable } from 'rxjs';

import { NAME_PATTERN } from '@fcom/core/utils';
import {
  SubmitService,
  ETicketReceiptFormData,
  pnrFormatValidator,
  PrefillProfileData,
  ETicketReceiptResponseData,
} from '@fcom/service-forms';

import { FormBuilderGroup, FormBuilderInput, ETicketReceiptFormField } from '../interfaces';

@Component({
  selector: 'fin-e-ticket-receipt-form',
  template: `
    <fin-form-builder
      [controlConfig]="controlConfig"
      [submitHandler]="submitHandler"
      formName="e-ticket-receipt"
      translationPrefix="eTicketReceiptForm"
    >
    </fin-form-builder>
  `,
})
export class ETicketReceiptFormComponent {
  controlConfig: FormBuilderGroup[] = [
    {
      controlName: 'eTicketReceipt',
      fields: [
        {
          type: FormBuilderInput.TEXT,
          controlName: ETicketReceiptFormField.LAST_NAME,
          translationPrefix: 'SERVICE_FORMS.serviceForms.fields.lastName',
          controlConfig: ['', [Validators.required, Validators.pattern(NAME_PATTERN)]],
          prefillFromProfile: PrefillProfileData.LAST_NAME,
        },
        {
          type: FormBuilderInput.TEXT,
          controlName: ETicketReceiptFormField.RESERVATION_NUMBER,
          translationPrefix: 'SERVICE_FORMS.serviceForms.fields.reservationNumber',
          placeHolder: 'SERVICE_FORMS.serviceForms.fields.reservationNumber.placeholder',
          controlConfig: ['', [Validators.required, pnrFormatValidator()]],
        },
      ],
    },
  ];
  constructor(private submitService: SubmitService) {
    this.submitHandler = this.submitHandler.bind(this);
  }

  submitHandler(values: ETicketReceiptFormData): Observable<ETicketReceiptResponseData> {
    return this.submitService.eTicketReceipt(values);
  }
}
